import { useState, type ReactNode } from "react";
import {
  PrimaryControlsStripExpansionContext,
  createPrimaryControlsStripExpansionRegistry,
} from "#primary-controls-strip-expansion-context";

/** Wraps the subtree containing both `PrimaryControlsStripExpansionHost` and `PrimaryControlsStripExpansion` callsites. */
export function PrimaryControlsStripExpansionProvider({ children }: { children: ReactNode }) {
  const [registry] = useState(() => createPrimaryControlsStripExpansionRegistry());
  return (
    <PrimaryControlsStripExpansionContext.Provider value={registry}>
      {children}
    </PrimaryControlsStripExpansionContext.Provider>
  );
}
